import StyleOverrider from 'mrf/utils/StyleOverrider';
import InputBase from 'styles/basic/InputBase';
import tw, { styled } from 'twin.macro';

import 'react-calendar/dist/Calendar.css';
import 'react-clock/dist/Clock.css';
import 'react-date-picker/dist/DatePicker.css';
import 'react-datetime-picker/dist/DateTimePicker.css';

const DefaultStyledDateTimePicker = styled(InputBase)`
    && {
        ${tw`w-full`}
        input[type=number] {
            -moz-appearance: textfield;
        }
        &:disabled {
            ${tw`bg-transparent`}
        }
        .icon {
            ${tw`w-5 h-5 hover:text-primary-dark`}
        }

        .react-datetime-picker, .react-date-picker {
            ${tw`w-full`}
            
            &__wrapper {
                ${tw`border-0`}
            }

            &__inputGroup {
                ${tw`py-0 px-1 h-6 border-0 hocus:(py-0 outline-none border-0)`}

                &__input {
                    ${tw`py-0 rounded bg-transparent hocus:(py-0 outline-none border-0 ring-0 bg-card)`}
                    &:invalid {
                        ${tw`bg-transparent hocus:(bg-card)`}
                    }
                }
                ${'' /* &__divider {
                    ${tw`py-0 hocus:(py-0)`}
                } */}
            }

            &__button {
                ${tw`py-0 hocus:(py-0)`}
                &:enabled {
                    .react-datetime-picker__button__icon {
                        ${tw`hocus:(text-primary stroke-current)`}
                    }
                }
            }

            &__calendar {
                .react-calendar {
                    ${tw`p-2 border rounded`}
                    &__navigation {
                        button {
                            ${tw`bg-paper rounded mx-0.5`}
                        }
                    }
                    &__month-view {
                        button {
                            ${tw`rounded`}
                        }
                    }
                }
            }
        }
    }
`;

const [StyledDateTimePicker, setStyledDateTimePickerStyle] = StyleOverrider(DefaultStyledDateTimePicker);
export { DefaultStyledDateTimePicker, StyledDateTimePicker as default, setStyledDateTimePickerStyle };

